import { useQuery } from "@tanstack/react-query";
import useUser from "./useUser";
import { fetchTiers } from "../enums/queryFunction/Fetch";
import { TIER } from "../enums/QueryKeys";

export function useGetTiers() {

  const { data, isLoading, error } = useQuery({
    queryKey: [TIER],
    queryFn: () => fetchTiers(),
    staleTime: Infinity,
  });

  return { data, isLoading, error };
}